module.exports = __webpack_public_path__ + "img/Lens.6d5ddc6a.png";